var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91058 11.0773C2.23602 10.7519 2.76366 10.7519 3.08909 11.0773L5.83317 13.8214C6.15861 14.1468 6.15861 14.6745 5.83317 14.9999C5.50773 15.3254 4.9801 15.3254 4.65466 14.9999L1.91058 12.2558C1.58514 11.9304 1.58514 11.4028 1.91058 11.0773Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1124 4.73182C18.4245 4.39364 18.4035 3.86642 18.0653 3.55425C17.7271 3.24208 17.1999 3.26317 16.8877 3.60136L7.45293 13.8224C7.14076 14.1605 7.16185 14.6878 7.50004 14.9999C7.83822 15.3121 8.36544 15.291 8.67761 14.9528L14.43 8.72111C14.5905 8.54722 14.8634 8.54176 15.0308 8.7091L16.0775 9.75584C16.4029 10.0813 16.9306 10.0813 17.256 9.75584C17.5814 9.4304 17.5814 8.90277 17.256 8.57733L16.1386 7.45988C15.9804 7.30174 15.9753 7.04696 16.127 6.88263L18.1124 4.73182Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89885 10.7323L3.43438 9.2678C2.45807 8.29149 2.45807 6.70857 3.43438 5.73226L6.56552 2.60113C7.54183 1.62482 9.12474 1.62482 10.101 2.60113L11.5655 4.0656C12.5418 5.04191 12.5418 6.62482 11.5655 7.60113L8.43438 10.7323C7.45807 11.7086 5.87516 11.7086 4.89885 10.7323ZM4.61289 8.08929L6.07736 9.55375C6.4028 9.87919 6.93043 9.87919 7.25587 9.55375L10.387 6.42262C10.7124 6.09718 10.7124 5.56954 10.387 5.24411L8.92254 3.77964C8.5971 3.4542 8.06946 3.4542 7.74403 3.77964L4.61289 6.91077C4.28746 7.23621 4.28746 7.76385 4.61289 8.08929Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 16.6666C7.12674 16.6666 7.49984 16.2935 7.49984 15.8333C7.49984 15.373 7.12674 14.9999 6.6665 14.9999C6.20627 14.9999 5.83317 15.373 5.83317 15.8333C5.83317 16.2935 6.20627 16.6666 6.6665 16.6666ZM6.6665 18.3333C8.04722 18.3333 9.1665 17.214 9.1665 15.8333C9.1665 14.4525 8.04722 13.3333 6.6665 13.3333C5.28579 13.3333 4.1665 14.4525 4.1665 15.8333C4.1665 17.214 5.28579 18.3333 6.6665 18.3333Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCart);
export default __webpack_public_path__ + "static/media/hand-cart.d3a1ad66aa899b3041b441a7dcdd1408.svg";
export { ForwardRef as ReactComponent };